import React from 'react';
import EventSharpIcon from '@material-ui/icons/EventSharp';
import ScheduleSharpIcon from '@material-ui/icons/ScheduleSharp';

function CustomPickerIcon({ iconType }) {
  const styleObj = {
    fontSize: '1rem',
    cursor: 'pointer',
    padding: 0,
  };

  const renderIcon = () => {
    switch (iconType) {
      case 'calendar':
        return <EventSharpIcon style={styleObj} />;
      case 'watch':
        return <ScheduleSharpIcon style={styleObj} />;
      default:
        return <EventSharpIcon style={styleObj} />;
    }
  };

  return renderIcon();
}

export default CustomPickerIcon;
